import React, { FC } from 'react';
import {
  OrderedList as ChakraOrderedList,
  UnorderedList as ChakraUnorderdList,
  ListProps as ChakraListProps,
} from '@chakra-ui/react';

interface ListProps extends ChakraListProps {
  color?: string;
  children?: React.ReactNode;
  listStyleType?: string;
  ordered?: boolean;
  spacing?: string;
  unstyled?: boolean;
}

export const List: FC<ListProps> = ({
  color,
  children = undefined,
  listStyleType,
  ordered = false,
  spacing = '0.5em',
  unstyled = false,
  ...rest
}) => {
  const computedProps = {
    color,
    listStyleType,
    ...(unstyled && {
      listStyleType: 'none',
      ms: '0',
      ps: '0',
    }),
  };

  /**
   * DOM
   */
  if (ordered) {
    return (
      <ChakraOrderedList data-testid="core-ordered-list" spacing={spacing} {...computedProps} {...rest}>
        {children}
      </ChakraOrderedList>
    );
  }

  return (
    <ChakraUnorderdList data-testid="core-unordered-list" spacing={spacing} {...computedProps} {...rest}>
      {children}
    </ChakraUnorderdList>
  );
};
